import React from 'react';
import { LinkButton } from 'fronton-react';
import { ChevronRightIcon } from '@fronton/icons-react';
import { topLineSeeMoreStyles, topLineItemStyles } from './styles';
import { FromTablet } from 'common/components/adaptive/tablet';

type SeeMoreButtonTopProps = {
  seeAllButtonCaption: string;
  seeMoreLinkActual: string;
  seeMoreLinkOnClickHandler: () => void;
};

export const SeeMoreButtonTop: React.FC<SeeMoreButtonTopProps> = ({
  seeAllButtonCaption,
  seeMoreLinkActual,
  seeMoreLinkOnClickHandler,
}) => (
  <FromTablet>
    <div className={topLineItemStyles}>
      <LinkButton
        iconRight={<ChevronRightIcon />}
        variant="normal"
        size="s"
        href={seeMoreLinkActual}
        onClick={seeMoreLinkOnClickHandler}
        withExtraClickZone
        className={topLineSeeMoreStyles}
        data-qa="products-carousel-seemore-link"
      >
        {seeAllButtonCaption}
      </LinkButton>
    </div>
  </FromTablet>
);
